import React from 'react';
import './App.css';
import CustomNavbar from './components/CustomNavBar'
import splash from './splash2.jpg';
import logo from './TrueNorthSailing.png';
import laptop from './TrueNorthLaptop_small.png'
import watch from './Fenix3.png'
import transferIcon from './transferIcon.png'
import Name from './TrueNorthName.png'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CustomBtn from './components/CustomButton'
import  { FirebaseContext } from "./components/Firebase";
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';

//function App() {

class App extends React.Component {

//<img src={splash} style={{width: '100%',zIndex:'-1'}}/>


render() {

  const boxStyle = { 
      zIndex: 1,
      width: 'fit-content', 
      //backgroundColor: '#ffffff4d', 
      //borderRadius:'3px', 
      padding:'15px', 
      marginTop: '-40px',
      marginLeft: '80px',
      padding:'20px 5px 20px 5px',
      height: '100vh',
      boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.24), 0 6px 20px 0 rgba(0, 0, 0, 0.18)',
  };

  return (
    <div style={{height:'100%'}}>
    <div style={{minHeight:'92vh'}}>
      <img src={splash} style={{width: '100%', boxShadow:'0 8px 12px 0 rgba(0, 0, 0, 0.3), 0 6px 20px 0 rgba(0, 0, 0, 0.34)'}}/>
      <div style={{position:'absolute', top:'10px', width:'100%', height:'100%'}}>
      <CustomNavbar logo={false}></CustomNavbar>
      <Grid container direction="column" justify={'flex-start'} alignItems={'flex-start'} style={{width:'100%', height:'100%'}}>
          <img src={logo} style={{maxWidth: '26%', margin:'4% 4%', zIndex:1}} />
      </Grid>
      </div>
      <Grid container direction="column" justify={'center'} alignItems={'center'} style={{backgroundColor: '#d4d4d4', marginTop:'-12px'}}>
      <Grid container direction="row" justify={'center'} alignItems={'flex-end'}>
          <img src={Name} style={{maxHeight: '60px', margin:'35px 5px 0px 5px', zIndex:1}}/>
          <Typography variant="h5" style={{marginTop:'5px',paddingBottom:'10px', color:'black'}}>
                    Server and Garmin app.
          </Typography>
      </Grid> 
      <Typography variant="subtitle1" style={{padding:'3px 5px 15px 5px', color:'black', textAlign:'center'}}>
                    Connecting Garmin compatible devices with your yachts instruments.
      </Typography>
      <Grid container direction="row" justify={'center'} alignItems={'center'} style={{backgroundColor: '#d4d4d4', marginTop:'-12px'}}>
          <img src={laptop} style={{maxWidth: '43%', margin:'5px 5px 5px -6%', zIndex:1}}/>
          <img src={transferIcon} style={{maxWidth: '10%', marginLeft:'0px',marginRight:'6%', zIndex:1}}/>
          <img src={watch} style={{maxWidth: '17%', margin:'5px', zIndex:1}}/>
      </Grid> 
         <Link to="/TrueNorthServer" style={{textDecoration: 'none', margin:'2% 0px 30px 0px'}}><CustomBtn click={null} name={'Discover more'}></CustomBtn></Link>
      </Grid>
      </div>

      <div style={{minHeight:'8vh', boxShadow:'0 0px 12px 0 rgba(0, 0, 0, 0.4), 0 0px 20px 0 rgba(0, 0, 0, 0.4)', backgroundColor:'#313131'}}>
      <Grid container direction="row" justify={'center'} alignItems={'center'} style={{height:'8vh'}}>
      <Typography variant="body2" style={{color:'white', textAlign: 'center'}}>
                  Contact us at truenorthsailingsoftware@gmail.com | +27-84-600-6091
    </Typography>
      </Grid>
      </div> 


    </div>
    );
  }
}

export default App;
